import * as React from "react"
export const ProfileIcon = (props) => (
  <svg
    width={20}
    height={20}
    viewBox='0 0 20 20'
    fill='none'
    xmlns='http://www.w3.org/2000/svg'
    {...props}>
    <path
      d='M9.889 9.661a4.5 4.5 0 1 0 0-9 4.5 4.5 0 0 0 0 9m.908 2.7H8.98c-1.066.003-2.12.171-3.104.495a8.5 8.5 0 0 0-2.628 1.392 6.5 6.5 0 0 0-1.751 2.078 5.2 5.2 0 0 0-.608 2.448c0 .09.045.175.125.239.08.063.19.098.303.098H18.46a.53.53 0 0 0 .31-.122.33.33 0 0 0 .119-.256c-.005-1.689-.859-3.307-2.375-4.501s-3.572-1.867-5.717-1.87'
      fillRule='evenodd'
      clipRule='evenodd'
      stroke='currentColor'
      fill='currentColor'
    />
  </svg>
)
